<hb-modal-dialog heading="Performance Standard Library" [showFooter]="false">
  <div content>
    <div>
      <input class="form-item filter" placeholder="Search..." [(ngModel)]="filterText" (ngModelChange)="filterChanged()" type="text" />
      <span class="icon-search"></span>
      <button *ngIf="isBuildPM" class="btn btn-primary pull-right" (click)="multiSelectAndClose()">Select &amp; Close</button>
    </div>

    <br />

    <div class="section mb-3" [ngClass]="{ 'blue-outline': isItemSelected(item) && !isBuildPM }" *ngFor="let item of filteredPerformanceStandards">
      <div class="reference">
        <span class="title ml-2">Reference</span>
        <span class="header pull-right mr-2" (click)="changeView(item)">
          {{ addition[item.performanceStandardId]?.isFullView ? 'Overview' : 'Full View' }}
          <i *ngIf="!addition[item.performanceStandardId]?.isFullView" class="fa fa-angle-up"></i>
          <i *ngIf="addition[item.performanceStandardId]?.isFullView" class="fa fa-angle-down"></i>
        </span>
      </div>
      <div class="psname" [ngClass]="{ 'blue-selection': isItemSelected(item) && !isBuildPM }">
        <span class="ml-2">{{ item.reference }}</span>
        <span class="psname" *ngIf="!isBuildPM">
          <button class="btn btn-primary pull-right" (click)="onSelectClose(item)" *ngIf="!isItemSelected(item) && !isReadOnly">
            Select &amp; Close
          </button>
          <span class="pull-right mr-2" *ngIf="isItemSelected(item)"> Selected </span>
        </span>
        <span class="psname" *ngIf="isBuildPM">
          <input
            type="checkbox"
            style="width: 20px; height: 20px"
            class="btn btn-primary pull-right no-padding vertical-align:middle"
            [value]="item.performanceStandardId"
            [checked]="item.isSelected"
            (change)="onChange_checkbox($event, item.performanceStandardId, item)"
          />
        </span>
      </div>
      <div class="objective" [ngClass]="{ 'blue-back': isItemSelected(item) }">
        <span class="title ml-2">Objective</span>
      </div>
      <div class="objname p-2" [ngClass]="{ 'blue-back': isItemSelected(item) }">
        <span>{{ item.description }}</span>
      </div>
      <ng-container *ngIf="addition[item.performanceStandardId]?.isFullView">
        <div class="objective" [ngClass]="{ 'blue-back': isItemSelected(item) }">
          <span class="title ml-2">Scope &amp; Boundaries</span>
        </div>
        <div class="objname p-2" [ngClass]="{ 'blue-back': isItemSelected(item) }">
          <span>{{ item.scope }}</span>
        </div>
      </ng-container>

      <div class="tabsection">
        <table border="1" aria-hidden="true">
          <thead>
            <tr>
              <th scope="col" class="pl-2" width="150px">
                <span class="header" (click)="orderBy(item, 'reference')">
                  <i class="mr-2" [ngClass]="getOrderClass(item, 'reference')"></i>
                  Ref.
                </span>
              </th>
              <th scope="col" class="pl-2" width="150px">
                <span class="header" (click)="orderBy(item, 'type')">
                  <i class="mr-2" [ngClass]="getOrderClass(item, 'type')"></i>
                  Type
                </span>
              </th>
              <th scope="col" class="pl-2">
                <span class="header" (click)="orderBy(item, 'requirement')">
                  <i class="mr-2" [ngClass]="getOrderClass(item, 'requirement')"></i>
                  Requirement
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of item.requirements">
              <td class="ref title pt-1">
                <span class="req" [title]="row.reference" [ngClass]="{ 'blue-selection': isItemSelected(item) && !isBuildPM }">
                  {{ row.reference }}
                </span>
              </td>
              <td class="type req pl-2 pt-2">
                {{ row.type | requirementType }}
              </td>
              <td class="p-2" [ngClass]="{ req: !addition[item.performanceStandardId]?.isFullView }">
                {{ row.requirement }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</hb-modal-dialog>
